var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-row',{attrs:{"align":"center","justify":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","xs":"12","sm":"8","md":"4"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }